import React from 'react';
import { useLocation } from 'react-router-dom';
import Seo from './Seo';
import { getPageSeo, siteJsonLd } from '../data/seo';

// Dynamic detail routes own their SEO (set in-page after data loads).
const DYNAMIC_PREFIXES = ['/blog/', '/solutions/', '/case-studies/', '/legal/', '/lp/'];

// Mounted once in the marketing shell: applies per-route SEO for static pages
// and always injects site-wide Organization + WebSite JSON-LD.
export default function RouteSeo() {
  const { pathname } = useLocation();
  const isDynamic = DYNAMIC_PREFIXES.some((p) => pathname.startsWith(p));
  const cfg = isDynamic ? null : getPageSeo(pathname);

  // Site-wide structured data always present; page meta only for known static routes.
  const jsonLd = siteJsonLd();

  if (isDynamic || !cfg) {
    // Still emit site JSON-LD (no title override so the page/default title stands).
    return <Seo jsonLd={jsonLd} />;
  }
  return <Seo title={cfg.title} description={cfg.description} keywords={cfg.keywords} path={pathname} jsonLd={jsonLd} />;
}
